/* eslint-disable default-case */
import {
    WiDaySunny,WiCloudy,
    WiDayCloudy,
    WiCloudUp,
    WiCloudDown,
    WiThermometerExterior,
    WiThermometer,
    WiStrongWind,
    WiLightning,
    WiStormShowers,
    WiDaySleetStorm,
    WiSandstorm,
    WiDust,
    WiFog,
    WiDayRainMix,
    WiDayRain,
    WiHail,
    WiRain,
    WiSnow,
    WiSnowWind,
    WiThunderstorm,
    WiFlood,
    WiWindy,
    WiNA,WiDaySprinkle
} from 'weather-icons-react';
const getPhenom = {
    getWs: id => {
        switch (id) {
            case 1:
                return 'احتمال ';
            case 2:
                return 'با احتمال ';
            case 3:
                return 'بتدریج ';
            case 4:
                return 'در ارتفاعات ';
            case 5:
                return 'تا ';
            case 6:
                return 'دراواخر وقت ';
            case 7:
                return 'اواسط روز ';
            case 8:
                return 'اوایل شب ';
            case 9:
                return 'در بعضی ساعات ';
            case 10:
                return 'در بعدازظهر ';
            case 11:
                return 'در پاره ای نقاط ';
            case 12:
                return 'در سواحل ';
            case 13:
                return 'در طول روز ';
            case 14:
                return 'و';
            case 15:
                return '  واحتمال ';
            case 16:
                return 'همراه با';
            case 17:
                return 'با';
            case 18:
                return 'در شهرهای جنوبی  ';
            case 19:
                return 'در شهرهای شمالی ';
            case 20:
                return 'در شهرهای شرقی ';
            case 21:
                return 'در شهرهای غربی ';
            case 22:
                return ' در ';
            case 23:
                return '  گاهی ';
            case null:
                return '';
            default:
                return '';
        }
    }, getColorWs: coda => {
        switch (coda) {
            case 1:
                return "#f0ff00";
            case 2:
                return "#fff";
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 9:
            case 10:
                return "#1f3a93";
            case 11:
                return "#cf000f";
            case 14:
                return "yellow";
            case 15:
                return "#2e3131";
            case 16:
                return "#2e3131";
            case 17:
            case 18:
            case 19:
            case 20:
            case 37:
            case 21:
                return "#e99c61";
            case 22:
            case 23:
            case 24:
            case 25:
                return "#fff";
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
                return "#3a539b";
            case 32:
            case 33:
            case 34:
            case 35:
            case 36:
                return "#fff";
            case 38:
                return "#fff";
            default:
                return "#fff";
        }
    }, getNWsImg: coda => {
        switch (coda) {
            case 1:
            case 38:
            case 39:
                return require('../img/condition/wsymbol_0008_clear_sky_night_big_s1.png');
            case 2:
                return require('../img/condition/N_02_L.png');
            case 8:
            case 9:
                return require('../img/condition/N_05_L.png');
            case 3:
                return require('../img/condition/N_04_L.png');
            case 4:
            case 6:
                return require('../img/condition/wsymbol_0003_white_cloud_big_s1.png');
            case 7:
                return require('../img/condition/D_07_L.png');
            case 10:
                return require('../img/condition/N_10_L.png');
            case 11:
                return require('../img/condition/D_11_L.png');
            case 5:
                return require('../img/condition/wsymbol_0004_black_low_cloud_big_s1.png');
            case 12:
                return require('../img/condition/N_12_L.png');
            case 13:
            case 17:
                return require('../img/condition/wsymbol_0001_sunny_big_s1.png');
            case 14:
            case 15:
            case 16:
                return require('../img/condition/wsymbol_0016_thundery_showers_big_s1.png');
            case 18:
                return require('../img/condition/N_18_L.png');
            case 19:
                return require('../img/condition/wsymbol_0001_sunny_big_s1.png');
            case 20:
                return require('../img/condition/N_20_L.png');
            case 21:
            case 22:
            case 40:
                return require('../img/condition/wsymbol_0007_fog_big_s1.png');
            case 23:
                return require('../img/condition/N_23_L.png');
            case 24:
            case 25:
            case 26:
                return require('../img/condition/wsymbol_0006_mist_big_s1.png');
            case 27:
            case 28:
            case 29:
                return require('../img/condition/D_29_L.png');
            case 30:
            case 31:
                return require('../img/condition/wsymbol_0017_cloudy_with_light_rain_big_s1.png');
            case 32:
                return require('../img/condition/wsymbol_0018_cloudy_with_heavy_rain_big_s1.png');
            case 33:
            case 34:
                return require('../img/condition/wsymbol_0020_cloudy_with_heavy_snow_big_s1.png');
            case 35:
            case 36:
                return require('../img/condition/wsymbol_0021_cloudy_with_sleet_big_s1.png');
            case 37:
                return require('../img/condition/D_36_L.png');
            default:
                return require('../img/condition/nan.png');
        }
    },
    getFcIcon: (temp, rain, dpoint, wind) => {
        if (rain !== '0.0' && rain !== null && rain !== 0 ) {
            if (rain < 1) {
                return WiDaySprinkle;
            } else {
                if (temp > 0) {
                    return WiRain;
                } else {
                    return WiSnow;
                }
            }
        } else {
            if (wind > 6) {
                let rh =
                    100 *
                    (Math.exp((17.625 * dpoint) / (243.04 + dpoint)) /
                        Math.exp((17.625 * temp) / (243.04 + temp)));
                if (rh > 50) {
                    return 'WiDayCloudy-gusts';
                } else {
                    return WiWindy;
                }
            } else {
                if (temp > 20) {
                    let rh =
                        100 *
                        (Math.exp((17.625 * dpoint) / (243.04 + dpoint)) /
                            Math.exp((17.625 * temp) / (243.04 + temp)));
                    if (rh > 50) {
                        return WiDayCloudy;
                    } else {
                        return WiDaySunny;
                    }
                } else {
                    let rh =
                        100 *
                        (Math.exp((17.625 * dpoint) / (243.04 + dpoint)) /
                            Math.exp((17.625 * temp) / (243.04 + temp)));
                    if (rh > 50) {
                        return WiDayCloudy;
                    } else {
                        return WiDaySunny;
                    }
                }
            }
            // return 'WiDayCloudy';
        }
    },
    getWsIcon: coda => {
        switch (coda) {
            case 1:
                return WiDaySunny;
            case 2:
                return WiDayCloudy;
            case 3:
                return WiDayCloudy;
            case 4:
                return WiDayCloudy;
            case 5:
                return WiCloudy;
            case 6:
                return WiDayCloudy;
            case 7:
                return WiCloudUp;
            case 8:
                return WiCloudDown;
            case 9:
                return WiCloudUp;
            case 10:
                return WiThermometerExterior;
            case 11:
                return WiThermometer;
            case 12:
                return WiWindy;
            case 13:
                return WiStrongWind;
            case 14:
                return WiLightning;
            case 15:
                return WiStormShowers;
            case 16:
                return WiDaySleetStorm;
            case 17:
                return WiStrongWind;
            case 18:
                return WiSandstorm;
            case 19:
                return WiSandstorm;
            case 20:
                return WiDust;
            case 21:
                return WiDust;
            case 22:
                return WiDust;
            case 23:
                return WiFog;
            case 24:
                return WiFog;
            case 25:
                return WiFog;
            case 26:
                return WiDayRainMix;
            case 27:
                return WiDayRainMix;
            case 28:
                return WiDayRain;
            case 29:
                return WiHail;
            case 30:
                return WiHail;
            case 31:
                return WiRain;
            case 32:
                return WiRain;
            case 33:
                return WiSnow;
            case 34:
                return WiSnow;
            case 35:
                return WiHail;
            case 36:
                return WiSnowWind;
            case 37:
                return WiThunderstorm;
            case 38:
                return WiNA;
            case 39:
                return WiFlood;
            case 40:
                return WiWindy;
            case null:
                return WiNA;
            default:
                return WiNA;
        }
    },
    getWsTxt: coda => {
        switch (coda) {
            case 1:
                return ' صاف ';
            case 2:
                return ' کمی ابری ';
            case 3:
                return ' قسمتی ابری ';
            case 4:
                return ' نیمه ابری  ';
            case 5:
                return ' ابری ';
            case 6:
                return ' بتدریج ابری';
            case 7:
                return ' رشد ابر درارتفاعات ';
            case 8:
                return 'کاهش ابر';
            case 9:
                return ' افزایش ابر';
            case 10:
                return ' کاهش دما ';
            case 11:
                return 'افزایش دما ';
            case 12:
                return ' کاهش باد';
            case 13:
                return ' افزایش باد';
            case 14:
                return 'رعد وبرق ';
            case 15:
                return 'رگبار با رعد وبرق ';
            case 16:
                return 'رعد وبرق با بارش ';
            case 17:
                return 'وزش باد ';
            case 18:
                return 'باد وگرد وخاک';
            case 19:
                return 'وزش باد شدید';
            case 20:
                return 'غبار آلود';
            case 21:
                return 'غبار محلی';
            case 22:
                return 'غبار صحبگاهی';
            case 23:
                return 'مه آلود';
            case 24:
                return 'مه رقیق';
            case 25:
                return 'مه غلیظ';
            case 26:
                return 'بارش پراکنده';
            case 27:
                return ' بارش پراکنده';
            case 28:
                return ' ابري با احتمال بارش ';
            case 29:
                return 'بارش خفیف باران ';
            case 30:
                return 'رگبار باران ';
            case 31:
                return 'بارش باران   ';
            case 32:
                return 'بارش باران وبرف ';
            case 33:
                return 'رگبار برف ';
            case 34:
                return 'بارش برف';
            case 35:
                return 'تگرگ ';
            case 36:
                return 'کولاک برف';
            case 37:
                return 'توفان وگردوخاک';
            case 38:
                return 'دربا ارام';
            case 39:
                return 'دریا مواج';
            case 40:
                return 'هوا آلوده';
            case null:
                return '';
            case NaN:
                return '';
            case undefined:
                return '';
            default:
                return '';
        }
    },
    getWsImg: coda => {
        switch (coda) {
            case 1:
            case 38:
            case 39:
                return require('../img/condition/wsymbol_0001_sunny_big_s1.png');
            case 2:
                return require('../img/condition/D_02_L.png');
            case 8:
            case 9:
                return require('../img/condition/wsymbol_0002_sunny_intervals_big_s1.png');
            case 3:
                return require('../img/condition/D_04_L.png');
            case 4:
            case 6:
                return require('../img/condition/wsymbol_0003_white_cloud_big_s1.png');
            case 7:
                return require('../img/condition/D_07_L.png');
            case 10:
                return require('../img/condition/D_10_L.png');
            case 11:
                return require('../img/condition/D_11_L.png');
            case 5:
                return require('../img/condition/wsymbol_0004_black_low_cloud_big_s1.png');
            case 12:
                return require('../img/condition/D_12_L.png');
            case 13:
            case 17:
                return require('../img/condition/wsymbol_0001_sunny_big_s1.png');
            case 14:
            case 15:
            case 16:
                return require('../img/condition/wsymbol_0016_thundery_showers_big_s1.png');
            case 18:
                return require('../img/condition/D_18_L.png');
            case 19:
                return require('../img/condition/wsymbol_0001_sunny_big_s1.png');
            case 20:
                return require('../img/condition/D_20_L.png');
            case 21:
            case 22:
            case 40:
                return require('../img/condition/wsymbol_0007_fog_big_s1.png');
            case 23:
                return require('../img/condition/D_23_L.png');
            case 24:
            case 25:
            case 26:
                return require('../img/condition/wsymbol_0006_mist_big_s1.png');
            case 27:
            case 28:
            case 29:
                return require('../img/condition/D_29_L.png');
            case 30:
            case 31:
                return require('../img/condition/wsymbol_0017_cloudy_with_light_rain_big_s1.png');
            case 32:
                return require('../img/condition/wsymbol_0018_cloudy_with_heavy_rain_big_s1.png');
            case 33:
            case 34:
                return require('../img/condition/wsymbol_0020_cloudy_with_heavy_snow_big_s1.png');
            case 35:
            case 36:
                return require('../img/condition/wsymbol_0021_cloudy_with_sleet_big_s1.png');
            case 37:
                return require('../img/condition/D_36_L.png');
            default:
                return require('../img/condition/nan.png');
        }
    },
    getDirTxt: dwind => {
        switch (true) {
            case dwind >= 0 && dwind < 22:
                return 'شمالی(⬇️) ';

            case dwind >= 22 && dwind < 66:
                return 'شمال شرقی(↙️)  ';

            case dwind >= 66 && dwind < 111:
                return ' شرقی(⬅️)';

            case dwind >= 111 && dwind < 155:
                return 'جنوب شرقی(↖️)';

            case dwind >= 155 && dwind < 200:
                return 'جنوبی(⬆️)';

            case dwind >= 200 && dwind < 245:
                return 'جنوب غربی(↗️)';

            case dwind >= 245 && dwind < 290:
                return 'غربی(➡️)';

            case dwind >= 290 && dwind < 348:
                return 'شمال غربی(↘️)';

            case dwind >= 348 && dwind < 360:
                return 'شمالی(⬇️) ';
        }
    },
    getDirIcon: dwind => {
        switch (true) {
            case dwind >= 0 && dwind < 4:
                return 'icon1';

            case dwind >= 4 && dwind < 7:
                return 'icon4';

            case dwind >= 7 && dwind < 11:
                return 'icon7';

            case dwind >= 11 && dwind < 17:
                return 'icon11';

            case dwind >= 17 && dwind < 21:
                return 'icon17';

            case dwind >= 21:
                return 'iconu';
        }
    },
    getOsTxt: id => {
        switch (id) {
            case '1':
                return 'shargi_azarbayjan';
            case '2':
                return 'gharbi_azarbayjan';
            case '3':
                return 'ardabil';
            case '4':
                return 'esfahan';
            case '5':
                return 'ilam';
            case '6':
                return 'boshehr';
            case '7':
                return 'tehran';
            case '8':
                return 'char_bakhtyari';
            case '9':
                return 'kh_south';
            case '10':
                return 'kh_razavi';
            case '11':
                return 'kh_north';
            case '12':
                return 'khozestan';
            case '13':
                return 'zanjan';
            case '14':
                return 'semnan';
            case '15':
                return 'sistan_b';
            case '16':
                return 'fars';
            case '17':
                return 'qazvin';
            case '18':
                return 'qom';
            case '19':
                return 'kordestan';
            case '20':
                return 'kerman';
            case '21':
                return 'kermanshah';
            case '22':
                return 'ko_boyerahmad';
            case '23':
                return 'golestan';
            case '24':
                return 'gilan';
            case '25':
                return 'lorestan';
            case '26':
                return 'mazendran';
            case '27':
                return 'markazi';
            case '28':
                return 'hormozgan';
            case '29':
                return 'hamedan';
            case '30':
                return 'yazd';
            case '31':
                return 'alborz';
        }
    }
};

export { getPhenom };
